import { createRoute, type AnyRootRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AccountEmptyShell } from '@wehunt/ui'
import type { IconName } from '@wehunt/ui'

// Placeholder outfitter pages. Copy lives in the co-located @wehunt/ui `outfitter`
// namespace (registered app-wide via the i18n singleton), parity-checked with the
// rest of the lib bundles.
function OutfitterPage({ page, icon }: { page: string; icon: IconName }) {
  const { t } = useTranslation('outfitter')
  return (
    <AccountEmptyShell
      title={t(`${page}.title`)}
      subtitle={t(`${page}.subtitle`)}
      icon={icon}
      headline={t(`${page}.headline`)}
      body={t(`${page}.body`)}
    />
  )
}

export function buildOutfitterRoutes<TRoot extends AnyRootRoute>(rootRoute: TRoot) {
  const route = (path: string, page: string, icon: IconName) =>
    createRoute({
      getParentRoute: () => rootRoute,
      path,
      component: () => <OutfitterPage page={page} icon={icon} />,
    })

  return [
    route('/subscriptions', 'subscriptions', 'sparkle'),
    route('/orders', 'orders', 'cart'),
    route('/orders/$id', 'orderDetail', 'cart'),
    route('/addressbook', 'addressBook', 'pin'),
    route('/warranties', 'warranties', 'shield'),
    route('/settings/notifications', 'notifications', 'settings'),
  ]
}
